// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2knbU","content":"RecentSearches_content__1fr2z"};